import React, { useEffect, useState } from "react";
import "./WhatsAppLink.css";

const WhatsAppLink = () => {
  // const whatsappLink = /Mobi|Android/i.test(navigator?.userAgent)
  //     ? `https://api.whatsapp.com/send?phone=8956353503&text=%20`
  //     : `https://web.whatsapp.com/send?phone=8956353503&text=%20`;

  //   const whatsappLink = `https://web.whatsapp.com/send?phone=8956353503&text=%20`;
  const whatsappLink = `https://api.whatsapp.com/send?phone=918956353503&text=%20`;

  return (
    <>
      <div className="WhatsAppLink">
        <a target="_blank" rel="noopener noreferrer" href={whatsappLink} aria-label="Chat with us on WhatsApp">
          <div className="whatsapp_div" type="button">
            <img
              src="/assets/images/logo/wp.webp"
              className="img"
            />
          </div>
        </a>
      </div>
    </>
  );
};

export default WhatsAppLink;
